module.exports = __webpack_public_path__ + "static/media/mt_ln_4.e4eb4393.png";